const AuthenticationErrors = Object.freeze({
  PasswordMissing: 1,
  FailedUserLookup: 2,
  FailedAttempt: 3,
  FailedPasswordResetSend: 4,
  FailedPasswordReset: 5,
})

export default AuthenticationErrors
